import ButtonComponent from '../../../common/button-component/button-component';
import CustomModal from '../../../common/custom-modal/custom-modal';
import styles from './delete-modal.module.css';

interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

export default function DeleteModal({ isOpen, onClose, onConfirm, isDeleting }: DeleteModalProps) {
  if (!isOpen) return null;

  return (
    <CustomModal show={isOpen} onClose={onClose} width={420} modalBackdrop="dark">
      <div className={styles.modalContent}>
        <div className={styles.modalCopy}>
          <div className={styles.iconWrapper}>
            <span className={styles.warningIcon}>⚠️</span>
          </div>
          <h2 className={styles.title}>Delete Submission</h2>
          <p className={styles.message}>Are you sure you want to delete this submission?</p>
        </div>
        <div className={styles.modalActions}>
          <ButtonComponent type="button" onClick={onClose} className={styles.cancelButton} variant="secondary">
            Cancel
          </ButtonComponent>
          <ButtonComponent
            type="button"
            onClick={onConfirm}
            className={styles.deleteButton}
            showLoading={isDeleting}
            variant="danger"
          >
            Yes, Delete
          </ButtonComponent>
        </div>
      </div>
    </CustomModal>
  );
}
